import Category from "../components/Category";
import BreadcrumbShop from "../components/BreadcrumbShop";

const Accessories = () => {
  return (
    <div>
      <BreadcrumbShop curPage={"Accessories"} />
      <Category talk={"Accessories"} />
    </div>
  );
};

export default Accessories;
